import * as store from '@/store';
import {RteMethodProps} from '@/rte';

export enum serviceNames {
    ICommonUtilsService = 'ICommonUtilsService',
    IHeadingService = 'IHeadingService',
    ITransclusionService = 'ITransclusionService',
    IEditorStateService = 'IEditorStateService',
    IConfigService = 'IConfigService',
    IPrintService = 'IPrintService',
    INavigationService = 'INavigationService',
    ICommentService = 'ICommentService',
    IAIService = 'IAIService',
    IDiagramService = 'IDiagramService',
    IMindmapService = 'IMindmapService',
    IHtmlSerializerService = 'IHtmlSerializerService',
    IOnlineTodoListService = 'IOnlineTodoListService',
    ISlideViewService = 'ISlideViewService',
    ICoverService = 'ICoverService',
    IMaterialService = 'IMaterialService',
    IMarkdownSerializerService = 'IMarkdownSerializerService',
    ITransformService = 'ITransformService',
    ICardService = 'ICardService',
    IDragCoreService = 'IDragCoreService',
    IEmbedService = 'IEmbedService',
    IMentionService = 'IMentionService',
    INodeService = 'INodeService',
    ILayoutService = 'ILayoutService',
}

export function getMorphoService(serviceName: serviceNames, editor?: RteMethodProps) {
    if (!editor) {
        editor = store.getEditorRef().current!;
    }

    if (editor) {
        return editor.morphoServices(serviceName as any);
    }

    return null;
}

export function getEditorInstance(editor?: RteMethodProps) {
    if (!editor) {
        editor = store.getEditorRef().current!;
    }

    return editor.getEditorInstance();
}

export function focusToEditor(options: any, editor?: RteMethodProps) {
    const commonUtils = getMorphoService(serviceNames.ICommonUtilsService, editor);
    commonUtils.focusToEditor(getEditorInstance(editor), options);
}

export function disableToolbar(val: boolean, editor?: RteMethodProps) {
    const commonUtils = getMorphoService(serviceNames.ICommonUtilsService, editor);
    commonUtils.disableToolbar(getEditorInstance(editor), val);
}

export function scrollIntoBlock(
    options: {blockId?: string, headingUuid?: string, commentId?: string}, editor?: RteMethodProps
): boolean | null {
    if (options.blockId) {
        const transclusionService = getMorphoService(serviceNames.ITransclusionService, editor);
        if (transclusionService) {
            return transclusionService.scrollBlockIntoView(options.blockId);
        }
    }

    if (options.headingUuid) {
        const headingService = getMorphoService(serviceNames.IHeadingService, editor);
        if (headingService) {
            return headingService.scrollHeadingIntoView(options.headingUuid);
        }
    }

    if (options.commentId) {
        const commentService = getMorphoService(serviceNames.ICommentService, editor);
        if (commentService) {
            return commentService.scrollAndHighlightCommentBlock(options.commentId);
        }
    }

    // 没有结果
    return false;
}

export function getIsBrowserCompatiable(editor?: RteMethodProps) {
    const commonUtils = getMorphoService(serviceNames.ICommonUtilsService, editor);
    return commonUtils && commonUtils.isBrowserCompatiable && !commonUtils.isBrowserCompatiable();
}

export function getEditorElement(editor?: RteMethodProps) {
    const editorService = getMorphoService(serviceNames.IEditorStateService, editor);
    return editorService && editorService.getEditorElement();
}

/**
 * 记录文档的滚动位置
 */
export function setDocumentScrollPosition() {
    const editor = store.getEditorRef().current;
    if (editor) {
        const position = editor?.getEditorViewPosition();
        store.setDocumentPosition(position);
    }
}
